import { mergeSx } from "@/utils/styleHelpers";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function PassportHorizontalLockupCompact({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("PassportHorizontalLockupCompact");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 181 48"
      sx={mergeSx({ w: "200px", fill: "base.color.brand.1" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

PassportHorizontalLockupCompact.displayName = "PassportHorizontalLockupCompact";
